import React, { useEffect } from 'react';
import { Card, LoaderAnimated } from '../../components';
import { CampaignHome } from './CampaignHome.component';

import { useParams } from 'react-router-dom';
import { useCampaignDispatch } from './Campaigns.hooks';
import { useAppDispatch } from '../../store';
import { LogDealActionBar } from '../OpportunityManagement/LogDealActionBar.component';
import { apiService } from '../../services';
import { InteractionEventType } from 'outbound-api-client/lib/models';

export const CampaignTemplate: React.FC = () => {

  const dispatch = useAppDispatch();
  const { campaignId } = useParams();
  const { campaign, hasContent } = useCampaignDispatch(dispatch, campaignId || '');


  // Log "Page View" Interaction
  useEffect(() => {
    try {
      let path = window.location.pathname;
      apiService.postInteraction(InteractionEventType.WebPageView, 'PageView', path);
    } catch (err) {
      console.log(err);
    }
  }, []);


  const appId = process.env.REACT_APP_CLIENTID;
  if (appId === "zebratechnologies") {
    return (!campaign || !hasContent) ? <LoaderAnimated /> : <CampaignHome {...campaign} />
  }




  return (
    (!campaign || !hasContent) ? <LoaderAnimated /> :
      <Card cssClasses='m-x-0' contentCSS='p-x-0 p-bottom-2'>
        <div>
          <>
            <LogDealActionBar />
            <CampaignHome {...campaign} />
          </>
        </div>
      </Card>
  )
}